import * as React from "react";
import {Component} from "react";
import styles from "../../styles/wizards/superadmin/AddProductAttributeTemplateFieldWizard.scss";
import autobind from "autobind-decorator";
import AddProductAttributeTemplateFieldIcon from "../../assets/images/add-product-attribute-field-64x64.svg";
import {mapStateToProps, setTableParams, validateForm} from "../../core/utils";
import {withRouter} from "react-router";
import {setNotification} from "../../redux/actions/general/notification";
import {
    createProductAttributeTemplateField,
    listProductAttributeTemplateFields
} from "../../redux/actions/table/superadmin/product_attribute_template_fields";
import AddProductAttributeTemplateFieldForm
    from "../../forms/superadmin/add_product_attribute_template_field_wizard/AddProductAttributeTemplateFieldForm";
import {listLocalization} from "../../redux/actions/localization";

@withRouter
@mapStateToProps(state => ({
    table: state.table["superadmin_product_attribute_template_fields"],
}))
class AddProductAttributeTemplateFieldWizard extends Component {
    @autobind
    _handleSubmit(formData) {
        const {edit} = formData;

        return validateForm(
            createProductAttributeTemplateField(formData).then(({response}) => {
                listProductAttributeTemplateFields().then(() => {
                    if(edit) {
                        setTableParams('superadmin_product_attribute_template_fields', {
                            clicked_row: response.data.id
                        });
                    }
                });

                setTableParams('superadmin_product_attribute_template_fields', {
                    actioned_row: undefined,
                    selected_rows: []
                });

                this.props.onClose();

                setNotification("You have successfully added a new product attribute template field.");
            })
        );
    }

    render() {
        return (
            <>
                <div className={styles.header}>
                    <div className={styles.left}>
                        <span>Add product attribute template field</span>
                        <span>Add product attribute template field to the application</span>
                    </div>
                    <div className={styles.right}>
                        <AddProductAttributeTemplateFieldIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    <AddProductAttributeTemplateFieldForm onSubmit={this._handleSubmit} initialValues={{
                        label: {},
                        description: {}
                    }} />
                </div>
            </>
        );
    }
}

export default AddProductAttributeTemplateFieldWizard;